/**
 * The nav and footer groups are accordions on a phone and plain, always-open
 * columns on a desktop. CSS cannot force a <details> open, so the state is set
 * here. The breakpoint is read from --bp-desktop so this file does not become a
 * second place where that number lives.
 *
 * interactions.md §3.2: on a phone the first panel in a set is open by default.
 */
const breakpoint = getComputedStyle(document.documentElement)
  .getPropertyValue('--bp-desktop')
  .trim();

const desktop = matchMedia(`(min-width: ${breakpoint})`);

function sync() {
  document.querySelectorAll('[data-accordion-set]').forEach((set) => {
    set.querySelectorAll('[data-accordion]').forEach((group, index) => {
      group.open = desktop.matches || index === 0;
    });
  });
}

desktop.addEventListener('change', sync);
sync();
